export const getStaticPath = (url: string) => `${process.env.REACT_APP_STATIC_PATH_PUBLIC}/${url}`
